jQuery(document).ready(function ($) {
    'use strict';

    $(document.body).on('click', '.tab', function () {
        let tab_id = $(this).data('id');
        let tab_content = $('.tab-content[data-id*=' + tab_id + ']');

        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        tab_content.siblings().hide();
        tab_content.fadeIn();

    });

});

// Yoast accordion script
jQuery(document).ready(function ($) {
    $('.wp-block-yoast-faq-block .schema-faq-section:first').addClass('active');
    $('.wp-block-yoast-faq-block .schema-faq-question').click(function () {
        $('.wp-block-yoast-faq-block .active').removeClass('active');
        $(this).parent().addClass('active');
    });
});
//# sourceMappingURL=tabs.js.map
